import React, { useEffect, useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { db } from "../../firebase";
import { doc, getDoc } from "firebase/firestore";
import ChefRunGame from "./ChefRunGame";

const C = { bg: "#0a0a0f", surface: "rgba(255,255,255,0.05)", border: "rgba(255,255,255,0.09)", text: "#f5f5f7", secondary: "rgba(245,245,247,0.5)" };

export default function ChefRunWrapper() {
  const { localeTag, tableId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const tokenUrl = new URLSearchParams(location.search).get("token");
  const [loading, setLoading] = useState(true);
  const [tokenOk, setTokenOk] = useState(false);

  useEffect(() => {
    const check = async () => {
      try {
        if (!tokenUrl) return;
        const snap = await getDoc(doc(db, "locali", localeTag, "tavoli", tableId));
        if (snap.exists() && snap.data().tokenAttuale === tokenUrl) setTokenOk(true);
      } catch (e) { console.error(e); }
      finally { setLoading(false); }
    };
    check();
  }, [localeTag, tableId, tokenUrl]);

  if (loading) return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: C.bg, fontFamily: "-apple-system,'SF Pro Display',sans-serif" }}>
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "1rem" }}>
        <div style={{ width: 36, height: 36, border: "2px solid rgba(255,255,255,0.1)", borderTop: "2px solid rgba(245,245,247,0.6)", borderRadius: "50%", animation: "spin 0.8s linear infinite" }} />
        <p style={{ margin: 0, fontSize: "0.82rem", color: C.secondary }}>Caricamento…</p>
      </div>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );

  if (!tokenOk) return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: C.bg, padding: "2rem", fontFamily: "-apple-system,'SF Pro Display',sans-serif" }}>
      <div style={{ background: C.surface, border: `1px solid ${C.border}`, borderRadius: 24, padding: "2.5rem 2rem", maxWidth: 360, width: "100%", textAlign: "center", backdropFilter: "blur(20px)" }}>
        <div style={{ fontSize: "2.5rem", marginBottom: "1rem" }}>⏱</div>
        <h2 style={{ margin: "0 0 0.5rem", fontSize: "1.1rem", fontWeight: 700, color: C.text }}>Sessione scaduta</h2>
        <p style={{ margin: 0, fontSize: "0.85rem", color: C.secondary, lineHeight: 1.6 }}>Scansiona il QR del tavolo per iniziare una nuova sessione.</p>
      </div>
    </div>
  );

  return <ChefRunGame onBack={() => navigate(`/giochi/${localeTag}/${tableId}?token=${tokenUrl}`)} />;
}
